/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_upload_file_to_data_source_knowledge_base_api_v1_data_source_upload_file_post } from '../models/Body_upload_file_to_data_source_knowledge_base_api_v1_data_source_upload_file_post';
import type { Body_upload_text_to_data_source_knowledge_base_api_v1_data_source_upload_text_post } from '../models/Body_upload_text_to_data_source_knowledge_base_api_v1_data_source_upload_text_post';
import type { ChunkUpdateRequest } from '../models/ChunkUpdateRequest';
import type { DataSourceChunksResponse } from '../models/DataSourceChunksResponse';
import type { DataSourceResponse } from '../models/DataSourceResponse';
import type { DataSourceStatusResponse } from '../models/DataSourceStatusResponse';
import type { DataSourceToggleActiveResponse } from '../models/DataSourceToggleActiveResponse';
import { SortBy } from '../models/SortBy';
import { SortOrder } from '../models/SortOrder';
import type { StatusResultResponse } from '../models/StatusResultResponse';
import type { UploadFileResponse } from '../models/UploadFileResponse';
import type { UploadTextResponse } from '../models/UploadTextResponse';
import type { VectorizeDataSourceResponse } from '../models/VectorizeDataSourceResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DataSourceEndpointsService {
  /**
   * Vectorize Data Source
   * @param dataSourceId
   * @param embeddingModel Embedding model to use for vectorization
   * @param chunkSize Size of text chunks for vectorization
   * @param chunkOverlap Overlap between text chunks
   * @returns VectorizeDataSourceResponse Successful Response
   * @throws ApiError
   */
  public static vectorizeDataSourceKnowledgeBaseApiV1DataSourceDataSourceIdVectorizePost(
    dataSourceId: string,
    embeddingModel: string = 'text-embedding-3-small',
    chunkSize: number = 2500,
    chunkOverlap: number = 250
  ): CancelablePromise<VectorizeDataSourceResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/knowledge_base/api/v1/data_source/{data_source_id}/vectorize',
      path: {
        data_source_id: dataSourceId,
      },
      query: {
        embedding_model: embeddingModel,
        chunk_size: chunkSize,
        chunk_overlap: chunkOverlap,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Toggle Data Source Active
   * @param dataSourceId
   * @param active Set to True to activate or False to deactivate
   * @returns DataSourceToggleActiveResponse Successful Response
   * @throws ApiError
   */
  public static toggleDataSourceActiveKnowledgeBaseApiV1DataSourceDataSourceIdToggleActivePatch(
    dataSourceId: string,
    active: boolean = false
  ): CancelablePromise<DataSourceToggleActiveResponse> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/knowledge_base/api/v1/data_source/{data_source_id}/toggle-active',
      path: {
        data_source_id: dataSourceId,
      },
      query: {
        active: active,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Rename Data Source
   * @param dataSourceId
   * @param newName
   * @returns StatusResultResponse Successful Response
   * @throws ApiError
   */
  public static renameDataSourceKnowledgeBaseApiV1DataSourceDataSourceIdRenamePatch(
    dataSourceId: string,
    newName: string
  ): CancelablePromise<StatusResultResponse> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/knowledge_base/api/v1/data_source/{data_source_id}/rename',
      path: {
        data_source_id: dataSourceId,
      },
      query: {
        new_name: newName,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Data Source
   * @param dataSourceId
   * @returns DataSourceStatusResponse Successful Response
   * @throws ApiError
   */
  public static deleteDataSourceKnowledgeBaseApiV1DataSourceDataSourceIdDelete(
    dataSourceId: string
  ): CancelablePromise<DataSourceStatusResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/knowledge_base/api/v1/data_source/{data_source_id}',
      path: {
        data_source_id: dataSourceId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * List Data Sources
   * @param page Page number
   * @param limit Number of items per page
   * @param idKnowledgeBase Filter by knowledge base ID
   * @param taskType Filter by task type
   * @param fileType Filter by file type
   * @param active Filter by active status
   * @param status Filter by processing status
   * @param name Filter by name (case-insensitive partial match)
   * @param sortBy Sort field (id, created_at, file_type, task_type, status)
   * @param sortOrder Sort order (asc or desc)
   * @returns DataSourceResponse Successful Response
   * @throws ApiError
   */
  public static listDataSourcesKnowledgeBaseApiV1DataSourceListGet(
    page: number = 1,
    limit: number = 20,
    idKnowledgeBase?: string | null,
    taskType?: string | null,
    fileType?: string | null,
    active?: boolean | null,
    status?: string | null,
    name?: string | null,
    sortBy: SortBy = SortBy.ID,
    sortOrder: SortOrder = SortOrder.DESC
  ): CancelablePromise<DataSourceResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/knowledge_base/api/v1/data_source/list',
      query: {
        page: page,
        limit: limit,
        id_knowledge_base: idKnowledgeBase,
        task_type: taskType,
        file_type: fileType,
        active: active,
        status: status,
        name: name,
        sort_by: sortBy,
        sort_order: sortOrder,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Data Source Chunks
   * @param dataSourceId Data source ID to filter chunks
   * @param knowledgeBaseId
   * @param page
   * @param limit
   * @returns DataSourceChunksResponse Successful Response
   * @throws ApiError
   */
  public static getDataSourceChunksKnowledgeBaseApiV1DataSourceChunksGet(
    dataSourceId: string,
    knowledgeBaseId: string,
    page: number = 1,
    limit: number = 20
  ): CancelablePromise<DataSourceChunksResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/knowledge_base/api/v1/data_source/chunks',
      query: {
        data_source_id: dataSourceId,
        page: page,
        limit: limit,
        knowledge_base_id: knowledgeBaseId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Upload Text To Data Source
   * @param formData
   * @returns UploadTextResponse Successful Response
   * @throws ApiError
   */
  public static uploadTextToDataSourceKnowledgeBaseApiV1DataSourceUploadTextPost(
    formData: Body_upload_text_to_data_source_knowledge_base_api_v1_data_source_upload_text_post
  ): CancelablePromise<UploadTextResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/knowledge_base/api/v1/data_source/upload_text',
      formData: formData,
      mediaType: 'application/x-www-form-urlencoded',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Upload File To Data Source
   * @param formData
   * @returns UploadFileResponse Successful Response
   * @throws ApiError
   */
  public static uploadFileToDataSourceKnowledgeBaseApiV1DataSourceUploadFilePost(
    formData: Body_upload_file_to_data_source_knowledge_base_api_v1_data_source_upload_file_post
  ): CancelablePromise<UploadFileResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/knowledge_base/api/v1/data_source/upload_file',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Chunk View
   * @param knowledgeBaseId
   * @param chunkId
   * @param requestBody
   * @returns void Successful Response
   * @throws ApiError
   */
  public static updateChunkViewKnowledgeBaseApiV1KnowledgeBaseKnowledgeBaseIdChunkChunkIdPatch(
    knowledgeBaseId: string,
    chunkId: string,
    requestBody: ChunkUpdateRequest
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/knowledge_base/api/v1/knowledge_base/{knowledge_base_id}/chunk/{chunk_id}',
      path: {
        knowledge_base_id: knowledgeBaseId,
        chunk_id: chunkId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
